module.exports = __webpack_public_path__ + "static/media/icon logo jungle fruit300dpi.849f462b.png";